export const isProd = process.env.REACT_APP_MOD === "PROD";

export const API_LINK = process.env.REACT_APP_API_LINK;
export const API_TOKEN = process.env.REACT_APP_API_TOKEN;
export const API_PIN_TOKEN = process.env.REACT_APP_API_PIN_TOKEN;